import { Component } from 'react'
import nextCookie from 'next-cookies'
import { getUserInfo } from '../apiClient'
import { encrypt } from './cryptor'
import Router from 'next/router'

export const withAuthSync = (WrappedComponent, redirect) => {
	return class Auth extends Component {
		constructor(props) {
			super(props)
		}
		static async getInitialProps(ctx) {
			const loginURL = `${process.env.VNW_BASE_URL}/login?redirectURL=${ctx.asPath}&type=login`			
			const isNoIndex = ctx.asPath && ctx.asPath.indexOf('?') >= 0

			const redirectOnError = () => {
				if (typeof window !== 'undefined') {
					Router.push(loginURL)
					return
				}
				ctx.res.writeHead(302, { Location: loginURL }).end()
				return
			}
			const { VNW128450527232960, VNWWS128450527232960 } = nextCookie(ctx)
			if (redirect && (!VNW128450527232960 || !VNWWS128450527232960)) {
				redirectOnError()
				return
			}
			let user = null
			if (!!VNW128450527232960 && !!VNWWS128450527232960) {
				const jsData = VNW128450527232960
				const wsData = VNWWS128450527232960
				try {
					const userRes = await getUserInfo(jsData, wsData)
					user = userRes ? userRes[0]?.attributes : null
					if (redirect && !user) {
						redirectOnError()
						return
					}
				} catch (err) {
					console.error(err)
				}
			}

			const componentProps =
				WrappedComponent.getInitialProps &&
				(await WrappedComponent.getInitialProps(ctx))
			if (user) {
				const { accessToken, refreshToken } = user
				user = {
					...user,
					accessToken: encrypt(accessToken),
					refreshToken: encrypt(refreshToken)
				}
			}

			const userIP = ctx?.req?.ip ?? null
			const userId = ctx?.req?.query?.userId ?? userIP

			if (user && user.userId && userIP) {
				user.userIp = userIP
			}
			
			return { ...componentProps, user, userIP: userId, noIndex: isNoIndex }
		}

		render() {
			return <WrappedComponent {...this.props} />
		}
	}
}
